import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/utils/common-tool.js'
import '@css/style.scss'
import 'vant/lib/index.css'


// Vant
import { Toast } from 'vant'
import { Popup, Picker, DatetimePicker, Button, Empty, Tabbar, TabbarItem, Icon, Dialog, Loading } from 'vant'
import { Radio, RadioGroup } from 'vant'
import { Collapse, CollapseItem } from 'vant'
import { Cascader } from 'vant'
import { Field } from 'vant'
import { Image } from 'vant';
import { List, PullRefresh } from 'vant';

Vue.use(Toast)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(DatetimePicker)
Vue.use(Cascader)
Vue.use(Field)
Vue.use(Image)
Vue.use(Button)
Vue.use(Empty)
Vue.use(List)
Vue.use(PullRefresh)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Icon)
Vue.use(Dialog)
Vue.use(Loading)


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
